<template>
  <div>
    <el-select v-model="selectValue" placeholder="Select Province" :disabled="disabled">
      <el-option
          v-for="item in selectData"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { provinceData } from '../../common-data/config.js';

export default {
  name: "ProvinceSelect",

  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {

    return {
      selectValue: "",
      selectData: provinceData,
    }
  },

  watch: {
    value(newValue) {
      this.selectValue = newValue
    },

    selectValue(newValue) {
      this.$emit("input", newValue)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>